import React, { MutableRefObject } from 'react';
import { Grid } from '@material-ui/core';

import ScrollSpeedAction from '../actions/ScrollSpeedAction';
import PlayPrompterAction from '../actions/PlayPrompterAction';
import HomeAction from '../actions/HomeAction';
import BookMarkAction from '../actions/BookMarkAction';
import ExitStudioAction from '../actions/ExitStudioAction';
import SettingAction from '../actions/SettingAction';
import AudioLevel from '../actions/AudioLevel';
import HelpAction from '../actions/HelpAction';
import Timer from './Timer';
import RecordAction from './actions/RecordAction';
import { StudioControlStyles } from '../styles';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};

const CameraControlsMobile = ({ refPrompter }: Props) => {
  const classes = StudioControlStyles();

  return (
    <>
      <Grid item container className={classes.mainControl}>
        <Grid item container xs={12} spacing={2} style={{ margin: 'unset' }}>
          <Timer />
          <RecordAction />
          <PlayPrompterAction />
          <ScrollSpeedAction />
          <AudioLevel />
        </Grid>
        <Grid item container xs={12} spacing={2} style={{ margin: 'unset' }}>
          <ExitStudioAction />
          <HomeAction />
          <BookMarkAction refPrompter={refPrompter} />
        </Grid>
      </Grid>
      <Grid
        item
        container
        className={classes.settingActionContainer}
      >
        <HelpAction />
        <Grid item style={{ marginTop:8 }}>
          <SettingAction />
        </Grid>
      </Grid>
    </>
  );
};

export default CameraControlsMobile;
